import React from 'react';
import PropTypes from 'prop-types';

import ConfigCard from 'components/common/config-card/ConfigCard';

const CouponItem = ({
    name = 'No name',
    code = 'None',
    onEditCoupon = null,
    markedForRemoval = false
}) => {
    return (
        <ConfigCard
            style={{
                width: '200px',
                height: '90px'
            }}
            onClickEditButton={() => onEditCoupon()}
            markedForRemoval={markedForRemoval}
        >
            <div className='coupon-item-card'>
                <div className='coupon-item-title font-family-bold'>{name}</div>
                {
                    code &&
                        <div className='brand-primary-color text-uppercase font-size-14'>{`CODE - ${code}`}</div>
                }
            </div>
        </ConfigCard>
    );
}

CouponItem.propTypes = {
    name: PropTypes.string,
    code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onEditCoupon: PropTypes.func,
    markedForRemoval: PropTypes.bool
}

export default CouponItem;